export const english = {
    AUTOMATE_title: 'Task Automation',

    COMMON_submit: 'Submit',
    COMMON_next: 'Next',
    COMMON_on: 'On',
    COMMON_off: 'Off',
    COMMON_field_required: 'This field is required.',
    COMMON_offline_message: 'You are offline. Please reconnect to save tasks.',
    COMMON_cancel: 'Cancel',
    COMMON_confirm: 'Confirm',
    COMMON_delete: 'Delete',
    COMMON_back: 'Back',
    COMMON_loading: 'LOADING',
    COMMON_testing_actions: 'Testing task...',
    COMMON_no_results: 'No items to display',
    COMMON_search_placeholder: 'Search...',
    COMMON_search_hint: 'Check spelling or try searching with a different keyword',
    COMMON_close: 'Close',
    COMMON_change: 'Change',
    // leave spaces between '(' and 'required' and ')' for better readability in the UI
    COMMON_required_label: '( required )',
    // leave spaces between '(' and 'optional' and ')' for better readability in the UI
    COMMON_optional_label: '( optional )',

    SORT_prefix: 'Sort by:',
    SORT_created_newest: 'Created (newest)',
    SORT_created_oldest: 'Created (oldest)',
    SORT_updated_newest: 'Updated (newest)',
    SORT_updated_oldest: 'Updated (oldest)',
    SORT_name_atoz: 'Name (A to Z)',
    SORT_name_ztoa: 'Name (Z to A)',

    TASKS_my_tasks: 'My tasks',
    TASKS_add_new: 'New',
    TASKS_blank_task: 'Blank task',
    TASKS_total_tasks_label: 'total tasks',
    TASKS_active_tasks_label: 'active tasks',
    TASKS_activations_label: 'task activations',
    TASKS_time_saved_label: 'time saved',
    TASKS_created: 'created on',
    TASKS_minutes_saved: 'min. saved',
    TASKS_unit_minutes: 'minutes',
    TASKS_unit_activations: 'activations',
    TASKS_unit_tasks: 'tasks',
    TASKS_delete_confirm_message: 'Are you sure you want to delete this task?',
    TASKS_no_tasks: 'Your task list is empty. Add a new task using the link below.',
    TASKS_plan_title: 'Your plan',
    TASKS_plan_upgrade: 'Upgrade',
    TASKS_plan_end_date: 'Plan end date',
    TASKS_plan_tier: 'Plan name',
    TASKS_plan_tier_free: '30 Days Trial Plan',
    TASKS_plan_tier_pricing: 'Price Per Automation',
    TASKS_plan_tier_free_price: 'Free up to 100',
    TASKS_plan_usage: 'Usage',
    TASKS_plan_usage_reset: 'Resets on',
    TASKS_plan_usage_of: 'of',
    TASKS_plan_usage_used: 'automations used',

    TASK_name: 'Task Name',
    TASK_name_placeholder: 'Enter task name here...',
    TASK_trigger_section_title: 'When this happens',
    TASK_actions_section_title: 'Then do this',
    TASK_save: 'Save Task',
    TASK_unsaved_message:
        "This task has unsaved changes. Don't forget to save your task before leaving this page.",
    TASK_unsaved_dialog_title: 'Save changes before continuing?',
    TASK_unsaved_dialog_message:
        'This task has unsaved changes. Do you want to save your task before leaving this page?',
    TASK_unsaved_dialog_discard: 'Discard changes',
    TASK_unsaved_dialog_save: 'Save and continue',
    TASK_authenticated: 'Authenticated',
    TASK_not_authenticated: 'Not Authenticated',
    TASK_authenticate: 'Authenticate',
    TASK_reauthenticate: 'Reauthenticate',
    TASK_reauthenticate_hint:
        'This ${itemType} is already authenticated, but you can reauthenticate if necessary.',
    TASK_authentication: 'Authentication',
    TASK_configuration: 'Configuration',
    TASK_authentication_required_trigger: 'This trigger requires authentication.',
    TASK_authentication_required_action: 'This action requires authentication.',
    TASK_add_action: 'Add Action',
    TASK_delete_trigger: 'Delete Trigger',
    TASK_delete_action: 'Delete Action',
    TASK_no_trigger_configurations: 'No configuration is required.',
    TASK_no_action_configurations: 'No configuration is required.',
    TASK_delete: 'Delete',
    TASK_add_task_item: 'Add ${itemType}',
    TASK_item_type_trigger: 'Trigger',
    TASK_item_type_action: 'Action',
    TASK_item_type_trigger_adverb: 'When',
    TASK_item_type_action_adverb: 'Then',
    TASK_connector_select_placeholder: 'Select a Connector',
    TASK_add_task_item_summary:
        'Select a Connector and a ${itemType} to see configuration details.',
    TASK_add_task_select_placeholder: 'Select a ${connector} ${itemType}',
    TASK_validation_trigger: 'Trigger required to continue.',
    TASK_validation_actions: 'At least one action is required to continue.',
    TASK_validation_authentication: 'Authentication required for all connectors.',
    TASK_validation_name: 'Task name required to continue.',
    TASK_validation_phone_number:
        'Invalid phone number provided. Please use the format +1234567890',
    TASK_validation_incomplete_trigger_config: 'Trigger is not fully configured.',
    TASK_validation_incomplete_action_config: 'Action is not fully configured.',
    TASK_test: 'Test Task',
    TASK_test_success_message: 'Task ran successfully.',
    TASK_search_placeholder: 'Search...',
    TASK_select: 'Select a',
    TASK_select_trigger: 'Select a trigger',
    TASK_select_action: 'Select an action',
    TASK_when_hint: 'Select the app that you want to use as the activation point of your task.',
    TASK_then_hint: 'Select the app that should perform some actions when your task is activated.',
    TASK_log_history: 'History',
    TASK_log_history_title: 'View history for task',
    TASK_create_success_message:
        'Good job. Your task is created. Here are a list of tasks you recently added. You can turn these on or off as needed.',
    TASK_save_success_message: 'Task saved successfully.',
    TASK_add_output_button_label: 'Add trigger output',
    TASK_create_with_errors:
        'Task was created with errors and has been disabled. See notifications for details.',
    TASK_save_with_errors:
        'Task was saved with errors and has been disabled. See notifications for details.',
    TASK_enable_failed: 'Failed to enable task due to errors. See notifications for details.',
    TASK_external_configuration_info:
        'You will need to complete these additional configuration steps in ${connectorProvider} before this task can function:',
    TASK_external_configuration_link: 'For more information please visit the',
    TASK_no_config_required: 'No configuration is required.',
    TASK_nothing_selected: 'Please select a trigger or action first.',

    FILTER_filter: 'Filter',
    FILTER_show_all: 'Show all',
    FILTER_filter_by_connector: 'Filter by connector',
    FILTER_filter_by_status: 'Filter by status',
    FILTER_filter_status_active: 'Active',
    FILTER_filter_status_inactive: 'Inactive',
    FILTER_filter_status_all: 'All',
    FILTER_filter_clear_all: 'Clear all filters',

    TASK_BUILDER_selected_options: 'Selected trigger event and action(s):',
    TASK_BUILDER_selection_hint: 'Select a trigger and some action(s) to build a new task.',
    TASK_BUILDER_step_1_title: 'Step 1 - Pick a trigger app',
    TASK_BUILDER_step_2_title: 'Step 2 - Pick a trigger event',
    TASK_BUILDER_step_3_title: 'Step 3 - Pick some action app(s)',
    TASK_BUILDER_step_4_title: 'Step 4 - Pick some action(s)',
    TASK_BUILDER_preview_hint: 'When this event happens -> your task will perform these actions.',
    TASK_BUILDER_create: 'Create Task',
    TASK_BUILDER_send_request_before: "Can't find what you are looking for? ",
    TASK_BUILDER_send_request: 'Send a request',
    TASK_BUILDER_send_request_after: " for an app you'd like.",

    BOOMI_AI_what: 'What are you looking for?',
    BOOMI_AI_what_offline: 'You are offline. Reconnect to use Boomi AI.',
    BOOMI_AI_thinking: 'Creating your task...',
    BOOMI_AI_unable:
        "I'm sorry, I wasn't able to understand what Task to make you. Could you reword your Task request please?",
    BOOMI_AI_try_again: 'Sorry. Please try again.',
    BOOMI_AI_decision_yes: "Yes. Let's go.",
    BOOMI_AI_decision_no: "No. Let's try again.",
    BOOMI_AI_go: 'Go',
    BOOMI_AI_submit: 'Submit prompt',

    USER_MENU_home: 'Tasks',
    USER_MENU_profile: 'Profile',
    USER_MENU_connections: 'Connections',
    USER_MENU_notifications: 'Notifications',
    USER_MENU_sign_out: 'Sign Out',

    USER_PROFILE_greeting: 'Hello',
    USER_PROFILE_picture_header: 'Profile picture',
    USER_PROFILE_save_image: 'Save',
    USER_PROFILE_change_image: 'Change',
    USER_PROFILE_scale_image: 'Scale',

    USER_CONNECTIONS_heading: 'Connections',
    USER_CONNECTIONS_description:
        'Search applications Task Automation is authorized to access. Connections can be deleted at any time. Deleting connections will stop any tasks connected to them.',
    USER_CONNECTIONS_search: 'Search connections...',
    USER_CONNECTIONS_no_items: 'Create some tasks to add connections.',
    USER_CONNECTIONS_permissions: 'Permissions',
    USER_CONNECTIONS_api_keys: 'API Key',
    USER_CONNECTIONS_basic_auth: 'Basic Auth',
    USER_CONNECTIONS_custom_auth: 'Auth',
    USER_CONNECTIONS_tasks: 'Tasks',
    USER_CONNECTIONS_delete_text:
        'Are you sure you want to delete the "${connectorName}" connection?',
    USER_CONNECTIONS_delete_cancel: 'Cancel',
    USER_CONNECTIONS_one_related_tasks_number: '1 related task',
    USER_CONNECTIONS_multi_related_tasks_number: '${numberOfTests} related tasks',
    USER_CONNECTIONS_related_tasks_text: ' will also be deleted. This cannot be undone.',

    USER_NOTIFICATIONS_heading: 'Notifications',
    USER_NOTIFICATIONS_all_read: 'Mark all as read',
    USER_NOTIFICATIONS_delete_read: 'Delete all read',
    USER_NOTIFICATIONS_select_placeholder: 'All tasks...',
    USER_NOTIFICATIONS_one_more_message: '+ 1 more error',
    USER_NOTIFICATIONS_two_plus_more_message: '+ ${extraNotificationsNeeded} more errors',

    ERROR_saving_one_task: 'There was an error saving the task "${taskName}".',
    ERROR_deleting_task: 'There was an error deleting the task "${taskName}".',
    ERROR_saving_multiple_tasks: 'There was an error saving your tasks.',
    ERROR_getting_tasks: 'There was an error retrieving your tasks.',
    ERROR_updating_profile_picture: 'There was an error updating your profile picture.',
    ERROR_reading_all_notifications: 'There was an error marking your notifications as read.',
    ERROR_deleting_read_notifications: 'There was an error deleting your read notifications.',
    ERROR_reading_single_notification: 'There was an error marking your notification as read.',
    ERROR_deleting_connector_token: 'There was an error deleting your connector token.',
    ERROR_getting_authentication_status: 'There was an error getting your authentication status.',
    ERROR_getting_webhooks: 'There was an error retrieving your webhooks.',
    ERROR_deleting_webhook: 'There was an error deleting your webhook.',
    ERROR_getting_task_logs: 'There was an error getting logs for this task.',
    ERROR_unknown: 'An error has occurred',

    ALERT_POPUP_copied: 'Copied to clipboard.',

    TIME_OFFSET_before: 'Before',
    TIME_OFFSET_after: 'After',
    TIME_OFFSET_clear: 'Clear',
    TIME_OFFSET_5min: '5 min',
    TIME_OFFSET_10min: '10 min',
    TIME_OFFSET_15min: '15 min',
    TIME_OFFSET_30min: '30 min',
    TIME_OFFSET_1hour: '1 hr',
    TIME_OFFSET_1day: '1 day',

    TASK_LOGS_header: 'History for "${taskName}"',
    TASK_LOGS_created_label: 'Task created',
    TASK_LOGS_enabled_label: 'Enabled',
    TASK_LOGS_disabled_label: 'Disabled',
    TASK_LOGS_trigger_activated_label: 'Trigger activated',
    TASK_LOGS_action_fired_label: 'Action fired',
    TASK_LOGS_action_failed_label: 'Action failed',
    TASK_LOGS_filter_placeholder: 'Event type',

    WELCOME_title: 'Welcome back',
    WELCOME_text: 'Automate all your mundane tasks & operations with the help of Task Automation.',

    // Boomi header headings
    BOOMI_HEADER_platform: 'Boomi Enterprise Platform',
    BOOMI_HEADER_home: 'Home',
    BOOMI_HEADER_discover: 'Discover',
    BOOMI_HEADER_products: 'Products',
    BOOMI_HEADER_labs: 'Labs',
    // Products
    BOOMI_HEADER_integration_title: 'Integration',
    BOOMI_HEADER_data_hub_title: 'Data Hub',
    BOOMI_HEADER_api_management_title: 'API Management',
    BOOMI_HEADER_event_streams_title: 'Event Streams',
    BOOMI_HEADER_flow_title: 'Flow',
    // Labs
    BOOMI_HEADER_spaces_title: 'Spaces',
    BOOMI_HEADER_bundles_title: 'Bundles',
    BOOMI_HEADER_integration_packs_title: 'Integration Packs',
    BOOMI_HEADER_process_library_title: 'Process Library',
    BOOMI_HEADER_connectors_title: 'Connectors',
};
